export const getFocusedLinkForRemoval = (state) => {
  return state.pages.projectView.modalData.removeProjectLink.focusedLink;
};
